var map = {
	"./asterix.svg": "67c3",
	"./calendar.svg": "5389",
	"./clock.svg": "c765",
	"./cloud.svg": "d6ed",
	"./cross.svg": "18a55",
	"./delete-icon.svg": "68e2",
	"./facebook.svg": "8ee7",
	"./file/file.svg": "c80e",
	"./file/jpg.svg": "0fb7",
	"./file/pdf.svg": "d724",
	"./file/png.svg": "1170",
	"./file/svg.svg": "f1e3",
	"./gplus.svg": "b08e",
	"./instagram.svg": "766b",
	"./list.svg": "f81c",
	"./pencil.svg": "7703",
	"./play--bright.svg": "9bbb",
	"./play.svg": "d068",
	"./shield--green.svg": "e96b",
	"./sidebar-menu.svg": "5d86",
	"./thumb-up--red.svg": "7819",
	"./twitter.svg": "d73f",
	"./vimeo.svg": "3523",
	"./youtube.svg": "28be"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b87c";